// extracted by mini-css-extract-plugin
module.exports = {"container":"NewRelease_container__3xt3g","Title":"NewRelease_Title__1lJuw"};